module.exports = __webpack_public_path__ + "img/138.a7f56859.jpg";